module.exports = __webpack_public_path__ + "img/ai2.6fb158e7.png";